import API from "./base.service";

export const getAllCountries = async () => {
    try {
        return await API.get(`/getAllCountry`);
    } catch (error) {
        console.error("Failed to get countries", error);
        throw error;
    }
};

export const getCitiesByCountry = async (countryId) => {
    try {
        return await API.get(`/getCitiesByCountry/${countryId}`);
    } catch (error) {
        console.error("Failed to get cities", error);
        throw error;
    }
};